"use client";
import { useCallback, useEffect, useState } from "react";
const useCarouselPrevNextButtons = (emblaApi, loop = true)=>{
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
    const [prevBtnHidden, setPrevBtnHidden] = useState(false);
    const [hasUserInteracted, setHasUserInteracted] = useState(false);
    const onPrevButtonClick = useCallback((event)=>{
        if (event) event.stopPropagation();
        if (!emblaApi) return;
        setHasUserInteracted(true);
        emblaApi.scrollPrev();
    }, [
        emblaApi
    ]);
    const onNextButtonClick = useCallback((event)=>{
        if (event) event.stopPropagation();
        if (!emblaApi) return;
        setHasUserInteracted(true);
        emblaApi.scrollNext();
    }, [
        emblaApi
    ]);
    const onSelect = useCallback((emblaApi)=>{
        const canScrollPrev = emblaApi.canScrollPrev();
        const canScrollNext = emblaApi.canScrollNext();
        setPrevBtnDisabled(!canScrollPrev);
        setNextBtnDisabled(!canScrollNext);
        if (loop || hasUserInteracted) setPrevBtnHidden(false);
        else {
            const isAtStart = 0 === emblaApi.selectedScrollSnap();
            setPrevBtnHidden(isAtStart);
        }
    }, [
        loop,
        hasUserInteracted
    ]);
    useEffect(()=>{
        if (!emblaApi) return;
        onSelect(emblaApi);
        emblaApi.on('reInit', onSelect).on('select', onSelect);
        const onPointerDown = ()=>setHasUserInteracted(true);
        emblaApi.on('pointerDown', onPointerDown);
        return ()=>{
            emblaApi.off('reInit', onSelect).off('select', onSelect).off('pointerDown', onPointerDown);
        };
    }, [
        emblaApi,
        onSelect
    ]);
    return {
        prevBtnDisabled,
        nextBtnDisabled,
        prevBtnHidden,
        onPrevButtonClick,
        onNextButtonClick
    };
};
export { useCarouselPrevNextButtons };
